const prefix = 'HEALTH/';

export const RECEIVED = `${prefix}RECEIVED`;
export const REQUESTING = `${prefix}REQUESTING`;
export const FAILED = `${prefix}FAILED`;
